import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Loading, Layout } from 'common/components/layout';
import { listClubs } from 'redux/clubs/actions';
import { useLocalization } from 'redux/localization/utils/hooks';

import Club from './list/Club';

const List = () => {
  const dispatch = useDispatch();
  const { t } = useLocalization();
  useEffect(() => {
    dispatch(listClubs());
  }, [dispatch]);

  const clubReducer = useSelector((state) => state.club);

  if (clubReducer.isListFetching || !clubReducer.data) {
    return <Loading />;
  }

  const clubIdArray = Object.keys(clubReducer.data);

  if (!clubIdArray.length) {
    return (
      <Layout title={t('clubSignup.general.wineClub')}>
        <section className="c7-content">
          <h1 className="c7-h1">{t('clubSignup.general.wineClub')}</h1>
          <p>{t('clubSignup.general.noClubsMessage')}</p>
        </section>
      </Layout>
    );
  }

  return (
    <Layout title={t('clubSignup.general.wineClub')}>
      <section className="c7-content">
        <h1 className="c7-h1">{t('clubSignup.general.wineClub')}</h1>
        <div className="c7-club-list">
          {clubIdArray.map((clubId) => (
            <Club key={clubId} club={clubReducer.data[clubId]} />
          ))}
        </div>
      </section>
    </Layout>
  );
};

export default List;
